import { create } from 'zustand';
import { images } from '@/data/images';
import { productImageMapping } from '@/data/product-image-mapping';
import type { ImageData, ImageMap, ProductImageMapping } from '@/types/image';

interface CatalogueState {
  // Image data (normalized)
  images: ImageMap;
  productImageMapping: ProductImageMapping;

  // Profit margin (percentage: 0 = no change, 20 = +20%, -20 = -20%)
  profitMargin: number;

  // Actions
  setImages: (images: ImageMap) => void;
  setProductImageMapping: (mapping: ProductImageMapping) => void;
  setProfitMargin: (margin: number) => void;

  // Selectors (derived state)
  getImageForProduct: (productCode: string) => ImageData | null;
}

export const useCatalogueStore = create<CatalogueState>((set, get) => ({
  // Initial state
  images: images,
  productImageMapping: productImageMapping,
  profitMargin: 0,

  // Actions
  setImages: (images) => set({ images }),
  setProductImageMapping: (mapping) => set({ productImageMapping: mapping }),
  setProfitMargin: (margin) => set({ profitMargin: margin }),

  // Selectors
  getImageForProduct: (productCode) => {
    const state = get();
    const imageId = state.productImageMapping.get(productCode);
    if (!imageId) return null;
    return state.images.get(imageId) || null;
  },
}));
